import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import loadable from '@loadable/component';

import OnlyPublicRoute from 'components/OnlyPublicRoute';
import * as authActions from 'features/auth/authSlice';
import * as authSelectors from 'features/auth/selectors';

const SignIn = loadable(() => import('features/auth/SignIn'));
const SignUp = loadable(() => import('features/auth/SignUp'));
const ForgotPassword = loadable(() => import('features/auth/ForgotPassword'));
const ResetPassword = loadable(() => import('features/auth/ResetPassword'));
const Legal = loadable(() => import('./Legal'));
const Product = loadable(() => import('./Product'));
const Faq = loadable(() => import('./Faq'));
const Contact = loadable(() => import('./Contact'));
const About = loadable(() => import('./About'));
const CookieBanner = loadable(() => import('./CookieBanner'));

const Homepage = () => {
  const match = useRouteMatch();
  const dispatch = useDispatch();
  const isCookieBannerAccepted = useSelector(authSelectors.getIsCookieBannerAccepted);

  if (!match) {
    return null;
  }

  const acceptCookieBanner = () => {
    dispatch(authActions.setCookieBanner(true));
  };

  return (
    <>
      <Switch>
        <Route path={match.path} exact>
          <Product />
        </Route>
        <Route path={`${match.path}faq`} exact>
          <Faq />
        </Route>
        <Route path={`${match.path}contact`} exact>
          <Contact />
        </Route>
        <Route path={`${match.path}about`} exact>
          <About />
        </Route>
        <OnlyPublicRoute path={`${match.path}sign-in`}>
          <SignIn />
        </OnlyPublicRoute>
        <OnlyPublicRoute path={`${match.path}sign-up`}>
          <SignUp />
        </OnlyPublicRoute>
        <OnlyPublicRoute path={`${match.path}forgot-password`}>
          <ForgotPassword />
        </OnlyPublicRoute>
        <OnlyPublicRoute path={`${match.path}reset-password/:token`} exact>
          <ResetPassword />
        </OnlyPublicRoute>
        <Route path={`${match.path}legal`}>
          <Legal />
        </Route>
      </Switch>
      {!isCookieBannerAccepted && <CookieBanner onAccept={acceptCookieBanner} />}
    </>
  );
};

export default Homepage;
